import debug from 'debug'

import { Order } from '@/data/Order'
import { PosScreen, router } from '@/pos/PosRouter'
import { order0, setOrder0 } from '@/react/OrderView/OrderViewShare'

import { mergeOrder } from '../conflict'
import { dataLock } from '../DataUtils'
import { generalSetting0, mainScreen } from '../PosSettingsSignal'
import { onBack } from '@/react/OrderView/OrderView'

const log = debug('order:conflict')

export async function resolveTableConflict() {
  await dataLock.acquireAsync()
  Order.$.subscribe(change => {
    if (change.operation === 'UPDATE' || change.operation === 'INSERT') {
      if (change.documentData.status === 'inProgress') {
        const currentOrder = order0()
        if (currentOrder.table === change.documentData.table && (router.screen === PosScreen.ORDER || router.screen === PosScreen.PAYMENT)) {
          const newOrder = mergeOrder(currentOrder, change.documentData)
          setOrder0(newOrder)
        }
      }
    } else if (change.operation === 'DELETE') {
      // FIXME: temporary disabled. This will cause the user exit to main screen when the order printed (not complete yet)
      // const currentOrder = order0()
      // if (currentOrder.table === change.documentData.table && (router.screen === PosScreen.ORDER || router.screen === PosScreen.PAYMENT)) {
      //   // router.screen = mainScreen()
      //   if (generalSetting0()?.hasTablePlan) onBack()
      //   else router.screen = mainScreen()
      // }
    }
  })
}
